import React, { useContext } from "react";
import { Button, Modal } from "react-bootstrap";
import ApplicationContext from "../../context/ApplicationContext";

export interface IMessageModalProps {
  close(): void;
  show: boolean;
  message: string;
  inError: boolean;
}

export const MessageModal: React.FC<IMessageModalProps> = (
  props: IMessageModalProps
): JSX.Element => {
  const context = useContext(ApplicationContext);

  function closeModal() {
    props.close();
  }

  const messageModal = (): JSX.Element => {
    return (
      <>
        <Modal show={props.show} onHide={() => closeModal()} size="sm">
          <Modal.Header closeButton>
            <Modal.Title>Info</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>
              <div>{props.inError ? "Error" : <></>}</div>
              <br />
              <div>
                <h3>{props.message}</h3>
              </div>
              <br />
            </>
          </Modal.Body>
          <Modal.Footer className="modal-footer">
            <div className="mr-auto"></div>
            <div>
              <Button
                className="btn bt-primary btn-lg"
                onClick={() => props.close()}
              >
                Close
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  return (
    <>
      <>{messageModal()}</>
    </>
  );
};
